import { ActionTree } from 'vuex';
import axios from 'axios';
import { IState } from './type';
import { IRootState } from '@/store/types';
import { getUserAssistance } from '@/server/model/timeline';
import { getResourceUrl } from '@/server/model/zeus';
import { Type, setCacheFile } from '@/sandbox';
import { formatPathByFilename, makeFile } from '@/sandbox/utils';
import router from '@/router';

const globalMutation = {
  root: true
};

// eslint-disable-next-line max-params
function createFileByFilename(
  filenames: string[],
  content: string,
  rootPath: string,
  preludeFiles: string[] = []
) {
  const files = filenames.map((name, index) => {
    const path = formatPathByFilename(name, rootPath);
    console.log(`/${name.replace(/^\//, '')}`, preludeFiles);
    return makeFile({
      path,
      content,
      isFromPrelude: preludeFiles.includes(`/${name.replace(/^\//, '')}`),
      isSelected: index === 0,
      downloadUrl: ''
    });
  });
  return files;
}

const actions: ActionTree<IState, IRootState> = {
  async getUserAssistance({ commit }, id) {
    // const res = await getUserAssistance({ id });
    // if (!res) {
    //   router.push('/404');
    //   return;
    // }
    // commit('sandbox/setRootPath', res.snapshot_path, globalMutation);
    // commit('setInfo', res);
    // const type = res.storage_type.indexOf(Type.normal) > -1 ? Type.normal : Type.jupyter;
    // commit('sandbox/setType', Type.jupyter, { root: true });
    // const url = await getResourceUrl(res.user_content_qiniu_key);
    // const { status, data } = await axios.get(url);
    // if (status === 200) {
    //   // commit('setResource', data);
    //   // commit('sandbox/setCompress', data.compress, globalMutation);
    //   const files = createFileByFilename(
    //     [res.file_name],
    //     data.content,
    //     res.snapshot_path,
    //     data.compress?.files
    //   );
    //   // commit(
    //   //   'sandbox/setFiles',
    //   //   {
    //   //     files
    //   //   },
    //   //   globalMutation
    //   // );
    //   // setCacheFile(files[0]);
    // }
  }
};

export default actions;
